import { MissionDetail } from '@/features/missions/ui/MissionDetail';

/**
 * §5: a page composes, it does not implement.
 */
export function MissionDetailPage({ missionId }: { missionId: string }) {
  return <MissionDetail missionId={missionId} />;
}
